import { axios } from "~/plugins/axios";
import moment from "moment";

const translate = {
  "31": "Обед",
  "32": "Перерыв",
  "33": "Другая работа",
  "34": "Постобработка",
  "35": "Омниканальность",
  "36": "Тренинг",
  "37": "Тех. перерыв",
  "sessions": "Сессии",
  "unreachables": "Отвалы",
  "incomingCalls": "Входящие вызовы",
  "outgoingLocalCalls": "Исходящие на внутренние номера",
  "outgoingCalls": "Исходящие на внешние номера",
  "outboundCalls": "Вызовы исходящей кампании"
}

const getDefaultState_Timeline = () => {
  return {
    timeline: {},
    timelineSum: {},
    resultLoaded: false,
  }
}
const state = getDefaultState_Timeline();

const getters = {
  timeline: state => state.timeline,
  timelineSum: state => state.timelineSum,
  resultLoaded: state => state.resultLoaded,
}

const actions = {
  async loadTimeline({commit}, payload) {
    const operator = {};
    commit('SET_TIMELINE', {});
    commit('SET_RESULT_LOADED', false);
    
    await axios.post('/api/reports/periods/calcFormulas', payload)
      .then(response => {
        operator.result = response.data;
        commit('SET_TIMELINE', operator);
        commit('SET_RESULT_LOADED', true);
      })
    await axios.post('/api/reports/periods/sessions', payload)
      .then(response => {
        operator.sessions = response.data;
      })
    await axios.post('/api/reports/periods/pauses', payload)
      .then(response => {
        operator.pauses = response.data;
      })
    await axios.post('/api/reports/periods/unreachables', payload)
      .then(response => {
        operator.unreachables = response.data;
      })
    await axios.post('/api/reports/periods/calls/incoming', payload)
      .then(response => {
        operator.incomingCalls = response.data;
      })
    await axios.post('/api/reports/periods/calls/outgoing', payload)
      .then(response => {
        operator.outgoingCalls = response.data;
      })
    await axios.post('/api/reports/periods/calls/outgoing_local', payload)
      .then(response => {
        operator.outgoingLocalCalls = response.data;
      })
    await axios.post('/api/reports/periods/calls/outbound', payload)
      .then(response => {
        operator.outboundCalls = response.data;
      })

    if (payload.sum) {
      let sum = {}

      for (let key in operator) {
        if (key === 'result') continue

        if (key === 'pauses') {
          let pauses = operator.pauses

          for (let key2 in pauses) {
            let oneSum = pauses[key2].items.reduce((acc, curr) => {
              let start = moment(curr.start)
              let end = moment(curr.end)
              let diff = moment.duration(end.diff(start))
              acc += diff.asMilliseconds() / 1000
              return acc
            }, 0)

            let n = oneSum / 60

            if (n) sum[pauses[key2].dname] = n.toFixed(1)
          }
        } else {
          let oneSum = operator[key].reduce((acc, curr) => {
            let start = moment(curr.start)
            let end = moment(curr.end)
            let diff = moment.duration(end.diff(start))
            acc += diff.asMilliseconds() / 1000
            return acc
          }, 0)

          let n = oneSum / 60

          let translateKey = key in translate
            ? translate[key]
            : key

          if (n) sum[translateKey] = n.toFixed(1)
        }
      }
      
      sum['Результат'] = (operator.result.diff_in_seconds / 60).toFixed(1)
      // console.log('loadTimelineSum', sum)

      commit('SET_TIMELINE_SUM', sum);

      // operator.sum = sum
    }

    commit('SET_TIMELINE', operator);
    return operator;
  },

  clearTimeline({commit}) {
    commit('RESET_STATE_TIMELINE');
  },
}

const mutations = {
  SET_TIMELINE_SUM(state, data) {
    state.timelineSum = data;
  },

  SET_TIMELINE(state, data) {
    state.timeline = data;
  },

  SET_RESULT_LOADED(state, data) {
    state.resultLoaded = data;
  },

  RESET_STATE_TIMELINE(state) {
    Object.assign(state, getDefaultState_Timeline())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
